import { ataChangelogsService } from '@/services/changelogs/ata-changelogs-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useAtaChangelogsQuery = (
  projectId: MaybeRefOrGetter<string>,
  ataId: MaybeRefOrGetter<string>,
) => {
  return useQuery({
    queryKey: computed(() =>
      projectKeys.ataChangelogs({
        projectId: toValue(projectId),
        ataId: toValue(ataId),
      }),
    ),
    queryFn: () => ataChangelogsService.getAllFromId(toValue(ataId)),
    enabled: computed(() => toValue(ataId) !== '0'),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
